// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes ink-enter {
  from {
    opacity: 0;
    transform: translateY(8px);
  }
  to {
    opacity: 1;
    transform: none;
  }
}
.afk-challenge-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.6);
  z-index: 9999;
  font-family: "Din-pro", "Segoe UI", system-ui, sans-serif;
}

.afk-challenge-panel {
  font-family: "Din-pro", "Segoe UI", system-ui, sans-serif;
  color: #ebe8e1;
  background: rgba(11, 15, 19, 0.96);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 6px;
  box-shadow: 0 18px 50px rgba(0, 0, 0, 0.6);
  backdrop-filter: blur(6px);
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  max-width: 92vw;
  padding: 22px 24px 18px;
  box-sizing: border-box;
  animation: afk-challenge-panel-in 0.16s ease-out;
  text-align: left;
}
.afk-challenge-panel * {
  box-sizing: border-box;
}
@media (prefers-reduced-motion: reduce) {
  .afk-challenge-panel {
    animation: none;
  }
}

@keyframes afk-challenge-panel-in {
  from {
    opacity: 0;
    transform: translate(-50%, -47%);
  }
  to {
    opacity: 1;
    transform: translate(-50%, -50%);
  }
}
.afk-challenge-icon {
  display: none;
}

.afk-challenge-title {
  font-family: "Marcellus", "Cinzel", Georgia, serif;
  font-weight: 400;
  font-size: 22px;
  line-height: 1.15;
  letter-spacing: 0.01em;
  color: #ebe8e1;
  margin: 0 0 8px;
}

.afk-challenge-hint {
  font-size: 14px;
  line-height: 1.5;
  color: #aeaba2;
  margin: 0 0 14px;
}

.afk-challenge-word {
  background: rgba(255, 255, 255, 0.04);
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 6px;
  margin-bottom: 12px;
  padding: 12px;
  text-align: center;
  font-family: "Din-pro", "Segoe UI", system-ui, sans-serif;
  font-size: 24px;
  font-weight: 600;
  letter-spacing: 0.04em;
  color: var(--gold-light);
  user-select: none;
}

.afk-challenge-input {
  width: 100%;
  padding: 9px 11px;
  font-family: "Din-pro", "Segoe UI", system-ui, sans-serif;
  font-size: 14px;
  color: #ebe8e1;
  background: rgba(0, 0, 0, 0.35);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 6px;
  user-select: text;
  font-size: 16px;
  text-align: center;
}
.afk-challenge-input:focus {
  outline: none;
  border-color: var(--gold-main);
}
.afk-challenge-input::placeholder {
  color: #8d8a82;
  font-family: "Din-pro", "Segoe UI", system-ui, sans-serif;
  text-transform: none;
  letter-spacing: normal;
  opacity: 1;
}
.afk-challenge-input--wrong {
  border-color: #d9786d;
}
.afk-challenge-input--wrong:focus {
  border-color: #d9786d;
}

.afk-challenge-error {
  margin: 8px 0 0;
  font-size: 13px;
  color: #d9786d;
}

.afk-challenge-actions {
  display: flex;
  justify-content: flex-end;
  margin-top: 16px;
}

.afk-challenge-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 8px 14px;
  font-family: "Din-pro", "Segoe UI", system-ui, sans-serif;
  font-size: 14px;
  font-weight: 600;
  line-height: 1.2;
  white-space: nowrap;
  color: #ebe8e1;
  background: rgba(255, 255, 255, 0.07);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 6px;
  cursor: pointer;
  transition: background-color 0.12s ease, border-color 0.12s ease, color 0.12s ease;
  color: #14100a;
  background: var(--gold-main);
  border-color: var(--gold-main);
}
.afk-challenge-btn:hover:not(:disabled) {
  background: rgba(255, 255, 255, 0.12);
  border-color: var(--gold-dark);
}
.afk-challenge-btn:active:not(:disabled) {
  transform: translateY(1px);
}
.afk-challenge-btn:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}
.afk-challenge-btn:focus-visible {
  outline: 2px solid var(--gold-light);
  outline-offset: 2px;
}
.afk-challenge-btn:hover:not(:disabled) {
  background: var(--gold-light);
  border-color: var(--gold-light);
}

.afk-challenge-countdown {
  font-size: 13px;
  line-height: 1.5;
  color: #8d8a82;
  margin: 14px 0 0;
}`, "",{"version":3,"sources":["webpack://./src/theme/_ink.scss","webpack://./src/components/AfkChallenge/AfkChallenge.scss"],"names":[],"mappings":"AAmLA;EACE;IAAO,UAAA;IAAY,0BAAA;EChLnB;EDiLA;IAAO,UAAA;IAAY,eAAA;EC7KnB;AACF;AANA;EACE,eAAA;EACA,QAAA;EACA,8BAAA;EACA,aAAA;EACA,yDDsBU;ACdZ;;AALA;EDsBE,yDAHU;EAIV,cAbK;EAoBL,kCAzBI;EA0BJ,0CAAA;EACA,kBAjBO;EAkBP,0CAAA;EACA,0BAAA;EChCA,eAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,eAAA;EACA,uBAAA;EACA,sBAAA;EACA,gDAAA;EACA,gBAAA;AAcF;ADAE;EAAI,sBAAA;ACGN;AAfE;EAZF;IAY4C,eAAA;EAmB1C;AACF;;AAjBA;EACE;IAAO,UAAA;IAAY,gCAAA;EAsBnB;EArBA;IAAO,UAAA;IAAY,gCAAA;EAyBnB;AACF;AAtBA;EAAsB,aAAA;AAyBtB;;AAvBA;EDsBE,kDA3BW;EA4BX,gBAAA;EACA,eCvBmB;EDwBnB,iBAAA;EACA,sBAAA;EACA,cAxCK;ECeL,eAAA;AA+BF;;AA5BA;ED0BE,eAAA;EACA,gBAAA;EACA,cA7CO;ECmBP,gBAAA;AAiCF;;AA7BA;EDKE,qCAjCW;EAkCX,2CAAA;EACA,kBA1BO;ECqBP,mBAAA;EACA,aAAA;EACA,kBAAA;EACA,yDDpBU;ECqBV,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,wBAAA;EACA,iBAAA;AAkCF;;AA/BA;ED+EE,WAAA;EACA,iBAAA;EACA,yDA7GU;EA8GV,eAAA;EACA,cAxHK;EAyHL,+BA5HU;EA6HV,0CAAA;EACA,kBAtHO;EAuHP,iBAAA;ECrFA,eAAA;EACA,kBAAA;AA0CF;AD4CE;EAAU,aAAA;EAAe,8BAAA;ACxC3B;ADyCE;EAAiB,cA7HV;EA6H0B,yDAtHvB;EAsHgD,oBAAA;EAAsB,sBAAA;EAAwB,UAAA;AClC1G;AAnDE;EACE,qBDxCK;AC6FT;AAnDI;EAAU,qBD1CL;ACgGT;;AAlDA;EACE,eAAA;EACA,eAAA;EACA,cDjDO;ACsGT;;AAlDA;EACE,aAAA;EACA,yBAAA;EACA,gBAAA;AAqDF;;AAjDA;EDCE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,iBAAA;EACA,yDA3DU;EA4DV,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAzEK;EA0EL,qCAAA;EACA,0CAAA;EACA,kBAvEO;EAwEP,eAAA;EACA,kFAAA;EASA,cAjFU;EAkFV,4BAAA;EACA,8BAAA;AC4CF;ADrDE;EAAyB,qCAAA;EAAuC,8BAAA;ACyDlE;ADxDE;EAA0B,0BAAA;AC2D5B;AD1DE;EAAa,YAAA;EAAc,mBAAA;AC8D7B;AD7DE;EAAkB,oCAAA;EAAsC,mBAAA;ACiE1D;ADzDE;EAAyB,6BAAA;EAA+B,+BAAA;AC6D1D;;AArFA;EDjBE,eAAA;EACA,gBAAA;EACA,cAlDO;ECmEP,gBAAA;AA0FF","sourcesContent":["// Shared look of the redesigned interfaces (escape menu, ALT menu, housing\n// drawer, and every other panel brought in line with them).\n//\n// Usage from any component stylesheet:\n//   @use '../../theme/ink' as ink;      // adjust the relative path\n//   .my-panel { @include ink.panel; }\n//\n// Rules the whole UI follows:\n//   - ink background, 1px light border, ONE corner radius (6px)\n//   - accent colour only through the palette tokens --gold-main/-light/-dark\n//     (never a hard-coded gold hex), so the palette picker keeps working\n//   - Marcellus for titles, Din-pro for everything else\n//   - no ornaments, no emoji, no centred decorative rules\n//   - hover and focus states on every control, reduced-motion respected\n//   - no color-mix() / relative colour syntax (older CEF in game)\n\n$ink: rgba(11, 15, 19, 0.96);\n$ink-raised: rgba(255, 255, 255, 0.04);\n$ink-field: rgba(0, 0, 0, 0.35);\n$line: rgba(255, 255, 255, 0.12);\n$line-strong: rgba(255, 255, 255, 0.2);\n$text: #ebe8e1;\n$text-2: #aeaba2;\n$text-3: #8d8a82;\n$danger: #d9786d;\n$success: #8fbf8a;\n$radius: 6px;\n$on-accent: #14100a;\n\n$font-title: 'Marcellus', 'Cinzel', Georgia, serif;\n$font-text: 'Din-pro', 'Segoe UI', system-ui, sans-serif;\n\n@mixin base {\n  font-family: $font-text;\n  color: $text;\n  * { box-sizing: border-box; }\n}\n\n// Floating panel (modals, centred prompts, docked windows).\n@mixin panel {\n  @include base;\n  background: $ink;\n  border: 1px solid $line-strong;\n  border-radius: $radius;\n  box-shadow: 0 18px 50px rgba(0, 0, 0, 0.6);\n  backdrop-filter: blur(6px);\n}\n\n// Raised block inside a panel.\n@mixin block {\n  background: $ink-raised;\n  border: 1px solid $line;\n  border-radius: $radius;\n}\n\n@mixin title($size: 22px) {\n  font-family: $font-title;\n  font-weight: 400;\n  font-size: $size;\n  line-height: 1.15;\n  letter-spacing: 0.01em;\n  color: $text;\n}\n\n@mixin lead {\n  font-size: 14px;\n  line-height: 1.5;\n  color: $text-2;\n}\n\n@mixin hint {\n  font-size: 13px;\n  line-height: 1.5;\n  color: $text-3;\n}\n\n@mixin label {\n  font-size: 13px;\n  font-weight: 600;\n  color: $text-2;\n}\n\n// Buttons: neutral by default; add the modifiers below for the other kinds.\n@mixin button {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  padding: 8px 14px;\n  font-family: $font-text;\n  font-size: 14px;\n  font-weight: 600;\n  line-height: 1.2;\n  white-space: nowrap;\n  color: $text;\n  background: rgba(255, 255, 255, 0.07);\n  border: 1px solid $line-strong;\n  border-radius: $radius;\n  cursor: pointer;\n  transition: background-color 0.12s ease, border-color 0.12s ease, color 0.12s ease;\n\n  &:hover:not(:disabled) { background: rgba(255, 255, 255, 0.12); border-color: var(--gold-dark); }\n  &:active:not(:disabled) { transform: translateY(1px); }\n  &:disabled { opacity: 0.4; cursor: not-allowed; }\n  &:focus-visible { outline: 2px solid var(--gold-light); outline-offset: 2px; }\n}\n\n@mixin button-primary {\n  color: $on-accent;\n  background: var(--gold-main);\n  border-color: var(--gold-main);\n\n  &:hover:not(:disabled) { background: var(--gold-light); border-color: var(--gold-light); }\n}\n\n@mixin button-danger {\n  color: $danger;\n  background: transparent;\n  border-color: rgba(217, 120, 109, 0.45);\n\n  &:hover:not(:disabled) { background: rgba(217, 120, 109, 0.14); border-color: $danger; }\n}\n\n@mixin button-quiet {\n  color: $text-3;\n  background: transparent;\n  border-color: transparent;\n\n  &:hover:not(:disabled) { color: $text; background: rgba(255, 255, 255, 0.07); border-color: transparent; }\n}\n\n@mixin button-sm {\n  padding: 5px 10px;\n  font-size: 13px;\n}\n\n@mixin field {\n  width: 100%;\n  padding: 9px 11px;\n  font-family: $font-text;\n  font-size: 14px;\n  color: $text;\n  background: $ink-field;\n  border: 1px solid $line-strong;\n  border-radius: $radius;\n  user-select: text;\n\n  &:focus { outline: none; border-color: var(--gold-main); }\n  &::placeholder { color: $text-3; font-family: $font-text; text-transform: none; letter-spacing: normal; opacity: 1; }\n}\n\n// Pill-shaped counters are the only rounded exception (small badges).\n@mixin badge {\n  display: inline-block;\n  min-width: 20px;\n  padding: 1px 7px;\n  font-size: 12px;\n  font-weight: 600;\n  text-align: center;\n  color: $text-2;\n  background: rgba(255, 255, 255, 0.09);\n  border-radius: 10px;\n}\n\n@mixin scroll {\n  overflow-y: auto;\n  scrollbar-width: thin;\n  scrollbar-color: rgba(255, 255, 255, 0.2) transparent;\n\n  &::-webkit-scrollbar { width: 6px; }\n  &::-webkit-scrollbar-thumb { background: rgba(255, 255, 255, 0.2); border-radius: 3px; }\n}\n\n@mixin enter($from: translateY(8px)) {\n  animation: ink-enter 0.16s ease-out;\n\n  @media (prefers-reduced-motion: reduce) { animation: none; }\n}\n\n@keyframes ink-enter {\n  from { opacity: 0; transform: translateY(8px); }\n  to   { opacity: 1; transform: none; }\n}\n\n// Tabs (underline style, as in the housing drawer).\n@mixin tab {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 9px 12px;\n  margin-bottom: -1px;\n  font-family: $font-text;\n  font-size: 14px;\n  font-weight: 600;\n  color: $text-2;\n  background: transparent;\n  border: 0;\n  border-bottom: 2px solid transparent;\n  cursor: pointer;\n\n  &:hover { color: $text; }\n  &:focus-visible { outline: 2px solid var(--gold-light); outline-offset: -2px; }\n}\n\n@mixin tab-active {\n  color: var(--gold-light);\n  border-bottom-color: var(--gold-main);\n}\n","@use '../../theme/ink' as ink;\n\n// \"Are you still there?\" prompt, centred over a dimmed screen.\n.afk-challenge-overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.6);\n  z-index: 9999;\n  font-family: ink.$font-text;\n}\n\n.afk-challenge-panel {\n  @include ink.panel;\n  position: fixed;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  max-width: 92vw;\n  padding: 22px 24px 18px;\n  box-sizing: border-box;\n  animation: afk-challenge-panel-in 0.16s ease-out;\n  text-align: left;\n\n  @media (prefers-reduced-motion: reduce) { animation: none; }\n}\n\n@keyframes afk-challenge-panel-in {\n  from { opacity: 0; transform: translate(-50%, -47%); }\n  to   { opacity: 1; transform: translate(-50%, -50%); }\n}\n\n// Decorative glyph, no longer displayed.\n.afk-challenge-icon { display: none; }\n\n.afk-challenge-title {\n  @include ink.title(22px);\n  margin: 0 0 8px;\n}\n\n.afk-challenge-hint {\n  @include ink.lead;\n  margin: 0 0 14px;\n}\n\n// The word to retype, shown exactly as it must be typed.\n.afk-challenge-word {\n  @include ink.block;\n  margin-bottom: 12px;\n  padding: 12px;\n  text-align: center;\n  font-family: ink.$font-text;\n  font-size: 24px;\n  font-weight: 600;\n  letter-spacing: 0.04em;\n  color: var(--gold-light);\n  user-select: none;\n}\n\n.afk-challenge-input {\n  @include ink.field;\n  font-size: 16px;\n  text-align: center;\n\n  &--wrong {\n    border-color: ink.$danger;\n\n    &:focus { border-color: ink.$danger; }\n  }\n}\n\n.afk-challenge-error {\n  margin: 8px 0 0;\n  font-size: 13px;\n  color: ink.$danger;\n}\n\n.afk-challenge-actions {\n  display: flex;\n  justify-content: flex-end;\n  margin-top: 16px;\n}\n\n// Single action of the view: primary.\n.afk-challenge-btn {\n  @include ink.button;\n  @include ink.button-primary;\n}\n\n.afk-challenge-countdown {\n  @include ink.hint;\n  margin: 14px 0 0;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
